export * from './IconFolderClosed';
